





























import { Component, Vue, Prop } from 'vue-property-decorator'
import Form, { CreateBoccoChannelFormValue } from '../form/CreateBoccoChannelForm.vue'


@Component({
    components: {
        'channel-edit-form': Form
    }
})
export default class ConfirmCreateBoccoChannelModal extends Vue {
    @Prop({required: true})
    value!: CreateBoccoChannelFormValue

    previewUrl: string | null = null

    editForm: CreateBoccoChannelFormValue | null = null


    get validEditForm() {
        if (this.value.name.length >= 4 && this.value.description.length != 0) {
            return true
        } else {
            return false
        }
    }

    mounted() {
        if (this.value.file) {
            this.previewUrl = window.URL.createObjectURL(this.value.file)
        }
        this.editForm = {...this.value}
    }

    updateForm() {
        this.$emit("input", this.editForm)
    }

}
